<style lang="scss">
.picker-regactivity {
  .sp-filter-form {
    padding: 8px 8px 0px 8px;
  }
  .sp-finder-hd {
    display: none;
  }
  .sp-finder {
    &.no-multiple {
      .sp-finder-bd {
        .el-table__fixed-header-wrapper {
          table thead {
            tr {
              th {
                &:nth-child(1) {
                  .el-checkbox {
                    display: none;
                  }
                }
              }
            }
          }
        }
      }
      .el-table__fixed-body-wrapper {
        top: 38px !important;
      }
    }
  }
  .el-pagination {
    margin: 0;
    padding: 10px;
  }
}
</style>
<template>
  <div class="picker-regactivity">
    <SpFinder
      ref="finder"
      :class="['shop-finder', { 'no-multiple': !multiple }]"
      :other-config="{
        'max-height': 600
      }"
      :data="tableData"
      :fixed-row-action="true"
      :setting="{
        columns: [
          { name: 'ID', key: 'activity_id', width: 80 },
          { name: '活动名称', key: 'activity_name' }
        ]
      }"
      :show-pager="false"
      @select="onSelect"
      @selection-change="onSelectionChange"
    />
  </div>
</template>

<script>
import BasePicker from './base'
import PageMixin from '../mixins/page'
export default {
  name: 'PickerPages',
  extends: BasePicker,
  mixins: [PageMixin],
  config: {
    title: '选择自定义活动'
  },
  props: ['value'],
  data() {
    return {
      tableData: [
        {
          activity_id: 1,
          activity_name: '限时团购',
          linkUrl: '/marketing/pages/item/group-list'
        },
        {
          activity_id: 2,
          activity_name: '百亿抢购',
          linkUrl: '/subpages/activity/billion-subsidy?type=0'
        },
        {
          activity_id: 3,
          activity_name: '百亿赠送',
          linkUrl: '/subpages/activity/billion-subsidy?type=1'
        },
        {
          activity_id: 4,
          activity_name: '一元商城',
          linkUrl: '/activity/yiyuan/yiyuan'
        },
        {
          activity_id: 5,
          activity_name: '团批商城',
          linkUrl: '/activity/tuanpi/tuanpi'
        },
        {
          activity_id: 6,
          activity_name: '电商礼品商城',
          linkUrl: '/marketing/pages/gross/index?gross_type=0'
        },
        {
          activity_id: 7,
          activity_name: '实体礼品商城',
          linkUrl: '/marketing/pages/gross/index?gross_type=1'
        },
        {
          activity_id: 8,
          activity_name: '消费券商城',
          linkUrl: '/activity/coupon/coupon'
        }
      ],
      formData: {
        keywords: ''
      },
      multiple: this.value?.multiple ?? true
    }
  },
  mounted() {
    const selectRows = this.tableData.filter((item) =>
      this.value.data.some((el) => el.item_id === item.activity_id)
    )
    const { finderTable } = this.$refs.finder.$refs
    setTimeout(() => {
      finderTable.$refs.finderTable.setSelection(selectRows)
    })
  },
  methods: {
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    onSelect(selection, row) {
      if (this.multiple) {
        // this.updateVal(selection)
      } else {
        const { finderTable } = this.$refs.finder.$refs
        console.log('finderTable:', finderTable)
        finderTable.clearSelection()
        setTimeout(() => {
          finderTable.$refs.finderTable.setSelection([row])
          // this.updateVal([row])
        })
      }
    },
    onSelectionChange(selection) {
      this.updateVal(selection)
    }
  }
}
</script>
